/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Geo_Point_FixesInputs */

const en_directory_hubs_signals_geo_point_fixes = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_FixesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most warnings are cheap fixes: add schema, expose dates, allow crawlers, render content server-side. Small changes move the score quickly.`)
};

const zh_directory_hubs_signals_geo_point_fixes = /** @type {(inputs: Directory_Hubs_Signals_Geo_Point_FixesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多数警告修起来很便宜：加 schema、暴露日期、放行爬虫、内容服务端渲染。小改动就能快速提分。`)
};

/**
* | output |
* | --- |
* | "Most warnings are cheap fixes: add schema, expose dates, allow crawlers, render content server-side. Small changes move the score quickly." |
*
* @param {Directory_Hubs_Signals_Geo_Point_FixesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_geo_point_fixes = /** @type {((inputs?: Directory_Hubs_Signals_Geo_Point_FixesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Geo_Point_FixesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_geo_point_fixes(inputs)
	return zh_directory_hubs_signals_geo_point_fixes(inputs)
});
export { directory_hubs_signals_geo_point_fixes as "directory.hubs.signals.geo.point.fixes" }